import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { environment } from '@env';

import { TDocument } from '@/types/document';

export const useGetDocument = (id: string, session: { access_token?: string } | null) =>
  useQuery<TDocument>({
    queryKey: ['GET', 'document', id, session?.access_token],
    queryFn: async () => {
      const response = await axios.get(`${environment.api}/document/${id}`, {
        headers: {
          Authorization: `Bearer ${session?.access_token}`,
        },
      });
      return response.data;
    },
    enabled: !!session?.access_token && !!id,
  });
